class LogoMarquee extends HTMLElement {
  constructor() {
    super();

    this.$marquee = this.querySelector('.js-logo-marquee');
    this.$pause = this.querySelector('.logo-marquee__pause');
    this.paused = false;
    this.setup();
    this.$pause.addEventListener('click', this.pause.bind(this));
  }

  pause() {
    if( this.paused ){
      this.$marquee.setAttribute('data-scrolling', true);
      this.$pause.setAttribute('aria-pressed', false);
      this.paused = false;
    }else{
      this.$marquee.setAttribute('data-scrolling', false);
      this.$pause.setAttribute('aria-pressed', true);
      this.paused = true;
    }
  }

  setup() {
    let clone = document.createElement('div');
    clone.className = 'logo-marquee__scroll  js-logo-marquee-scroll-clone';
    clone.innerHTML = this.$marquee.innerHTML;

    this.$marquee.appendChild(clone);
  }
}

customElements.define('logo-marquee', LogoMarquee);